
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 64 64","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"fill":"#D8D8D8","opacity":".347","cx":"32","cy":"32","r":"32"}}),_c('path',{attrs:{"d":"M41.234 46c.746 0 1.394-.274 1.943-.823A2.708 2.708 0 0044 43.19V28.857c0-.777-.274-1.44-.823-1.988-.55-.549-1.197-.823-1.943-.823h-1.35v-2.88a7.24 7.24 0 00-.923-3.6 6.99 6.99 0 00-2.503-2.606A6.538 6.538 0 0033 16c-1.251 0-2.404.32-3.458.96a6.99 6.99 0 00-2.503 2.606 7.24 7.24 0 00-.922 3.6h2.634c0-.777.193-1.509.577-2.195a4.368 4.368 0 011.564-1.628c.659-.4 1.361-.6 2.108-.6.747 0 1.45.2 2.108.6.658.4 1.18.943 1.564 1.628a4.42 4.42 0 01.577 2.195v2.88H24.766c-.746 0-1.394.274-1.943.823A2.708 2.708 0 0022 28.857V43.19c0 .777.274 1.44.823 1.988.55.549 1.197.823 1.943.823h16.468z","fill":"#000","fill-rule":"nonzero"}}),_c('path',{attrs:{"fill":"#F2F2F2","fill-rule":"nonzero","d":"M41 43H25V29h16z"}}),_c('path',{attrs:{"d":"M33 39c.81 0 1.512-.298 2.107-.893.595-.595.893-1.297.893-2.107 0-.81-.298-1.512-.893-2.107C34.512 33.298 33.81 33 33 33c-.81 0-1.512.298-2.107.893C30.298 34.488 30 35.19 30 36c0 .81.298 1.512.893 2.107.595.595 1.297.893 2.107.893z","fill":"#2CC692","fill-rule":"nonzero"}})])])
          )
        }
      }
    